import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth via httpOnly cookie (session_token). Sem localStorage: elimina vetor XSS.
export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// axios "cru" para rotas públicas (sem interceptor de auth)
export const publicApi = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const brl = (n) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};

export const STATUS_LABEL = {
  disponivel: "Disponível",
  ocupado: "Ocupado",
  manutencao: "Manutenção",
};

export const RESERVA_STATUS_LABEL = {
  "pre-reserva": "Pré-reserva",
  hospedado: "Hospedado",
  ativa: "Ativa",
  finalizada: "Finalizada",
  cancelada: "Cancelada",
};
